// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top p[data-v-291f0c38]{text-align:center;margin:0;padding:10px 0 0}.right h4[data-v-291f0c38]{margin:15px 0 5px}.left p[data-v-291f0c38],.right p[data-v-291f0c38]{font-size:14px;margin:5px 0 15px}[data-v-291f0c38]:export{green:#1989fa;white:#fff}", ""]);
// Exports
module.exports = exports;
